import React, { useState, useRef } from 'react';
import { useOddsStore } from '../../stores/store';
import { useEffect } from 'react';
import Choices from "choices.js";

// This component is used to sort the odds list by odds max or odds min
// It uses the odds store to manage the sort state

const SortSelect = () => {
  const [selectedOption, setSelectedOption] = useState('default');

  const setSort = useOddsStore(state => state.setSort);
  const sortRef = useRef(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSelectedOption(newValue);
    setSort(newValue);
  };

  useEffect(() => {
    setSort(selectedOption);
  }, [selectedOption, setSort]);

  useEffect(() => {
    if (sortRef.current) {
      
      new Choices(sortRef.current, {
        searchEnabled: false,
        removeItemButton: false,
        placeholderValue: sortRef.current.getAttribute("data-placeholder") || "Select",
        shouldSort: false,
        itemSelectText: '',
        allowHTML: true
      });
    }
  }, [])
  


  return (
    <div className="main-section__sort-select">
      <select
        id="sortSelect"
        name="options"
        className="custom-select"
        value={selectedOption}
        onChange={handleChange}
        ref={sortRef}
        data-placeholder="Sort by"
      >
        <option value="OddsMax">Odds max</option>
        <option value="OddsMin">Odds min</option>
      </select>
    </div>
  );
};

export default SortSelect;
